<template>
  <div id="btnsWrap">
    <div class="wrap" v-if="trial===true">
      <div class="frame-balloon" :style="balloonFrame">
        <div class="inr">
          <p>攻略本(試し読み)を読んで<br>出直しますか？</p>
        </div>
      </div>
      <div class="btns">
        <div class="icon"><img :src="`${publicPath}img/common/icon_kaguya.png`"></div>
          <ul>
            <li :style="btnFrame1">
              <div class="inr" @click.stop="onClick('yes')">はい</div>
              <div class="arrow" :style="arrowStyle"></div>
            </li>
            <li :style="btnFrame1">
              <div class="inr" @click.stop="onClick('no')">いいえ</div>
              <div class="arrow" :style="arrowStyle"></div>
            </li>
          </ul>
      </div>
    </div>
    <div class="wrap noTrial" v-if="trial===false">
      <div class="btns">
        <ul>
          <li :style="btnFrame2">
            <div class="inr" @click.stop="onClickTop">トップに戻る</div>
            <div class="arrow" :style="arrowStyle"></div>
          </li>
          <li :style="btnFrame2">
            <div class="inr" @click.stop="onClickRetry">もう一度挑戦する</div>
            <div class="arrow" :style="arrowStyle"></div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import _$ from 'jquery'
  // import _ from 'lodash'

  export default {
    name: 'BadEndSet',
    props: {
    },
    data() {
      return {
        publicPath: process.env.BASE_URL,
        balloonFrame: {
          backgroundImage: 'url(./img/common/pink_frm01_724_t.png),url(./img/common/pink_frm01_balloon.png), url(./img/common/pink_frm01_l.png), url(./img/common/pink_frm01_r.png)'
        },
        btnFrame1: {
          backgroundImage: 'url(./img/common/pink_frm02_287_t.png),url(./img/common/pink_frm02_287_b.png), url(./img/common/pink_frm02_l.png), url(./img/common/pink_frm02_r.png)'
        },
        btnFrame2: {
          backgroundImage: 'url(./img/common/pink_frm02_358_t.png),url(./img/common/pink_frm02_358_b.png), url(./img/common/pink_frm02_l.png), url(./img/common/pink_frm02_r.png)'
        },
        arrowStyle: {
          backgroundImage: 'url(./img/common/white_arw.png)',
        },
        timer: null,
        trial: false
      }
    },
    mounted() {
      this.blinkArrow()
      if(this.$parent.currentData.trial){
        this.trial = true
      }
    },
    destroyed() {
      this.stopTimer()
    },
    watch: {
    },
    methods: {
      onClick: function(val){
        this.$emit('selectBadEnd', val);
      },
      onClickTop(){
        this.$emit('backtoTop');
      },
      onClickRetry(){
        this.$emit('retryStory');
      },
      blinkArrow: function(){
        this.timer = setInterval(function(){
          _$('#btnsWrap .arrow').toggle()
        }.bind(this), 500)
      },
      stopTimer: function(){
        clearInterval(this.timer)
      }
    }
  }
</script>

<style lang="scss" scoped>
  #btnsWrap {
    margin: toVW(32) toVW(13) toVW(13);

    .frame-balloon {
      background-position: left top, left bottom, left top, right top;
      background-repeat: no-repeat, no-repeat, repeat-y, repeat-y;
      background-size: toVW(724) auto, toVW(724) auto, toVW(10) auto, toVW(10) auto;
      width: toVW(724);
      height: toVW(173);
      margin: 0 auto toVW(7);

      .inr {
        width: 100%;
        height: 100%;
        padding: toVW(40);
        text-align: center;
        line-height: 1.5;
        letter-spacing: .07em;
      }
    }

    .btns {
      display: flex;

      .icon {
        width: toVW(97);
        margin: toVW(12) toVW(32) 0 toVW(10);
        flex-shrink: 0;
      }

      ul {
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;

        li {
          background-position: top left, bottom left, left top, right top;
          background-repeat: no-repeat, no-repeat, repeat-y, repeat-y;
          background-size: toVW(287) auto, toVW(287) auto, toVW(15) auto, toVW(15) auto;
          width: toVW(287);
          height: toVW(120);
          flex-shrink: 0;
          position: relative;

          .inr {
            width: 100%;
            height: 100%;
            text-align: center;
            line-height: toVW(120);
          }

          .arrow {
            background-repeat: no-repeat;
            background-size: contain;
            width: toVW(21);
            height: toVW(28);
            position: absolute;
            top: calc((100% - 3.733vw) / 2);
            left: toVW(37);
            display: none;
          }
        }
      }
    }

    .noTrial {
      padding: toVW(180) 0 0;

      .btns ul li {
        background-size: toVW(358) auto, toVW(358) auto, toVW(15) auto, toVW(15) auto;
        width: toVW(358);
      }
    }
  }
</style>
